export const Title = (props: any) => {
  return <h2 {...props}>{props.children}</h2>
}
